import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface CustomerRequest {
    customer_memo: string;
}

export const usePostCustomerMemo = (
    successCallback?: () => void,
    customerId?: number,
): UseMutationResult<null, Error, CustomerRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, CustomerRequest>({
        mutationFn: async (customerMemoData: CustomerRequest) => {
            const response = await axios.post(
                enum_api_uri.post_customer_memo.replace(":customer_idx", customerId?.toString() || ""),
                customerMemoData,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerMemo"] });
            successCallback?.();
        },
        // onError: (error: Error) => {
        //     console.error("고객 생성 실패:", error);
        // },
        // isError로 수정해보기
    });
};
